import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';

const useFormFields = (initialFields, employeeList = []) => {
    const [fields, setFields] = useState(initialFields);
    const [errors, setErrors] = useState(
        Object.keys(initialFields).reduce((acc, key) => ({ ...acc, [key]: false }), {})
    );

    // const handleFieldChange = (name) => (event) => {
    //     const { value } = event.target;
    
    //     setFields(prevFields => {
    //         const updatedFields = { ...prevFields, [name]: value };
            
    //         // Check if the changed field is 'AccountToName'
    //         if (name === 'AccountToName') {
    //             console.log("Selected Account To Value:", value); // Log the selected value
    //             console.log("Employee List:", employeeList); // Log the employee list
                
    //             // Use Number() to match ID types if necessary
    //             const selectedEmployee = employeeList.find(employee => employee.id == value);
    //             console.log("Selected Employee:", selectedEmployee); // Log the found employee
                
    //             if (selectedEmployee) {
    //                 updatedFields.AccountType = selectedEmployee.account_type; 
    //             } else {
    //                 updatedFields.AccountType = ''; // Clear if not found
    //             }
    //         }
    
    //         return updatedFields;
    //     });
    // };
    

    const handleFieldChange = (key) => (e) => {
        let value = e.target.value;


        setFields(fields=>{
            const updateFields={ ...fields, [key]: value };

  if (key==='AccountToName') {
    const selectedEmployee=employeeList.find(employee=>employee.id==value);
    if (selectedEmployee) {
        updateFields.AccountType=selectedEmployee.account_type;
        
    } else {
        updateFields.AccountType='';
        
    }
  }
  return updateFields
        });
  
      // setErrors({ ...errors, [key]: false });
    };

    return { fields, errors, handleFieldChange, setFields, setErrors };
};

const validateFields = (fields, setErrors) => {
    const newErrors = {};
    let isValid = true;

    if (!fields.AccountType) {
        newErrors.AccountType = true;
        isValid = false;
    }
    if (!fields.AccountName) {
        newErrors.AccountName = true;
        isValid = false;
    }
    if (!fields.AccountToName) {
        newErrors.AccountToName = true;
        isValid = false;
    }

    setErrors(newErrors);
    return isValid;
};

const VendorForm = ({ onSave }) => {
    const navigate = useNavigate();
    const token = localStorage.getItem("token");

    const initialFields = {
        AccountToName: '',
        AccountType: '',
        AccountName: '',
        Amount: '',
        Date: '',
    };

    const [employeeList, setEmployeeList] = useState([]);
    const { fields, errors, handleFieldChange, setFields, setErrors } = useFormFields(initialFields, employeeList);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        const payload = {
            account_type: fields.AccountType,
            account_id: fields.AccountName,
            account_to_id: fields.AccountToName,
            amount: fields.Amount,
            date: fields.Date || new Date().toISOString().split("T")[0],
        };

        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to Transfer the Amount?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, update it!',
            cancelButtonText: 'No, cancel!',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
        });
    
        if (result.isConfirmed) {
            try {
                const response = await axios.post(`${process.env.REACT_APP_API_URL}Amount-transfer`, payload, {
                    headers: {
                        'Content-Type': 'application/json',
                        'x-access-token': token,
                    },
                });

                if (response.data.status === 200) {
                    Swal.fire({
                        title: 'Success',
                        text: 'Amount Transfer Successfully!',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });
                    setFields(initialFields);
                    onSave();
                    setTimeout(() => {
                        navigate('/Account-list');
                    }, 1000);
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: response.data.message,
                        icon: 'error',
                    });
                }
            } catch (error) {
                Swal.fire({
                    title: 'Error',
                    text: 'An error occurred during the update',
                    icon: 'error',
                });
            } finally {
                setLoading(false);
            }
        } else {
            Swal.fire('Cancelled', 'Amount Transfer has been cancelled', 'info');
        }
    };

    const handleSubmitEmployee = () => {
        if (validateFields(fields, setErrors)) {
            setLoading(true);
            handleSubmit();
        }
    };

    useEffect(() => {
        fetchEmployeeList();
    }, []);

    const fetchEmployeeList = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}Account-list`, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            });
            setEmployeeList(response.data.data || []);
          
        } catch (error) {
            console.error('Error fetching employee list:', error);
        }
    };

    return (
        <div id="addVendorModal">
            <Card>
                <Card.Body>
                    <Container fluid>
                        <Row>
                              <Col lg={4} sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="custom-label">Account To</Form.Label>
                                    <Form.Select
                                        value={fields.AccountToName}
                                        onChange={handleFieldChange('AccountToName')}
                                        className={errors.AccountToName ? 'is-invalid' : ''}
                                    >
                                        <option value="">Select</option>
                                        {employeeList.map((vendor) => (
                                            <option key={vendor.id} value={vendor.id}>
                                                {vendor.account_name}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>

                         
                            <Col lg={4} sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="custom-label">Account Type</Form.Label>
                                    <Form.Select
                                        value={fields.AccountType}
                                        onChange={handleFieldChange('AccountType')}
                                        className={errors.AccountType ? 'is-invalid' : ''}
                                        disabled={!fields.AccountToType} // Disable if no employee selected
                                    >
                                        <option value="">Select Account Type</option>
                                        <option value="Cash">Cash</option>
                                        <option value="Online">Online</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>


                       


                            <Col lg={4} sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="custom-label">Account From</Form.Label>
                                    <Form.Select
                                        value={fields.AccountName}
                                        onChange={handleFieldChange('AccountName')}
                                        className={errors.AccountName ? 'is-invalid' : ''}
                                    >
                                        <option value="">Select</option>
                                        {employeeList.map((vendor) => (
                                            <option key={vendor.id} value={vendor.id}>
                                                {vendor.account_name}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>

                            <Col lg={4} sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="custom-label">Amount</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Amount"
                                        value={fields.Amount}
                                        onChange={e => {
                                            let value = e.target.value.replace(/,/g, ''); // Remove commas for processing
                                            if (!isNaN(value) || value === "") {
                                                value = new Intl.NumberFormat().format(value); // Add commas back to the formatted value
                                                handleFieldChange('Amount')({ target: { value } }); // Call the handler to update state with the formatted value
                                            }
                                        }}
                                        className={errors.Amount ? 'is-invalid' : ''}
                                    />
                                </Form.Group>
                            </Col>

                            <Col lg={4} sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="custom-label">Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        placeholder="Date"
                                        value={fields.Date || new Date().toISOString().split("T")[0]}
                                        onFocus={(e) => e.target.showPicker()}
                                        onChange={handleFieldChange('Date')}
                                        className={errors.Date ? 'is-invalid' : ''}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Container>
                </Card.Body>
                <Card.Footer>
                    <div className="d-flex justify-content-end">
                        <Button variant="primary" className="btn btn-submit" onClick={handleSubmitEmployee} disabled={loading}>
                            {loading ? 'Submitting...' : 'Create'}
                        </Button>
                    </div>
                </Card.Footer>
            </Card>
        </div>
    );
};

export default VendorForm;
